import { render } from "./DeleteReconciliationConfirmationModal.vue?vue&type=template&id=1ef2ce68&ts=true"
import script from "./DeleteReconciliationConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./DeleteReconciliationConfirmationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__